<template>
  <div>
    <textarea
      ref="editor"></textarea>
  </div>
</template>

<script>
export default {
  name: 'wysiwyg',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    value(newValue) {
      // eslint-disable-next-line
      let editor = tinymce.get(this.$refs.editor.id);

      if (editor && editor.getContent() !== newValue) {
        editor.setContent(newValue);
      }
    }
  },
  mounted() {
    // eslint-disable-next-line
    tinymce.init({
      target: this.$refs.editor,
      height: 500,
      menubar: false,
      placeholder: '',
      plugins: 'table code fullscreen',
      advcode_inline: true,
      toolbar1: 'fullscreen | undo redo | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat code',
      toolbar2: 'table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
      setup: (editor) => {
        editor.on('init', () => {
          editor.setContent(this.value);
        });
        editor.on('change keyup', () => {
          let content = editor.getContent();
          this.$emit('input', content);
        });
      },
      branding: true
    });
  },
  beforeDestroy() {
    // eslint-disable-next-line
    if (tinymce.get(this.$refs.editor.id)) {
      // eslint-disable-next-line
      tinymce.get(this.$refs.editor.id).remove();
    }
  },
};
</script>
